import { getAuth } from 'firebase/auth';

export let access_token: string | undefined = undefined;

export async function refreshAuthToken(): Promise<string | undefined> {
  access_token = await getAuth().currentUser?.getIdToken();

  return access_token;
}

export function isTokenExpired(token: string) {
  const decodedToken = JSON.parse(atob(token.split('.')[1]));
  return decodedToken.exp < Date.now() / 1000;
}
